import React from 'react';

import Chip from '@material-ui/core/Chip';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Typography from '@material-ui/core/Typography';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import LinkIcon from '@material-ui/icons/Link';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

import Header from './Header';

const theme = createMuiTheme({
  palette: {
    primary: {
      main: '#f5f5f5',
      light: '#ffffff',
      dark: '#c2c2c2'
    },
    secondary: {
      main: '#29b6f6',
      light: '#73e8ff',
      dark: '#0086c3'
    },
  },
  typography: {
    useNextVariants: true,
  },
});

class APIRoute extends React.Component {
  render() {
    return (
      <ExpansionPanel>
        <ExpansionPanelSummary expandIcon={<ExpandMoreIcon />}>
          <Chip label={this.props.type} icon={<LinkIcon />} variant="default" color="secondary" style={{marginRight: '10px', borderRadius: '6px'}}/>
          <code style={{alignSelf: 'center'}}> {this.props.link}</code>
        </ExpansionPanelSummary>
        <ExpansionPanelDetails style={{flexDirection: "column", alignItems: "flex-start"}}>
          <Typography variant="subtitle1">
            <b>Parameters:</b> 
          </Typography>
          <code style={{textAlign: 'left', whiteSpace: 'break-spaces'}}>{this.props.params?JSON.stringify(this.props.params, null, 2):"None"}</code>
          <Typography variant="subtitle1">
            <b>Returns:</b> 
          </Typography>
          <code style={{textAlign: 'left', whiteSpace: 'break-spaces'}}>{JSON.stringify(this.props.return, null, 2)}</code>
          <Typography variant="body1" style={{marginTop: '5px', textAlign: 'left'}}>
            {this.props.description}
          </Typography>
        </ExpansionPanelDetails>
      </ExpansionPanel>
    );
  }
}

class APIReference extends React.Component {
  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <div className="App">
          <Header />
          <div className="Content" style={{marginTop: '20px'}}>
            <APIRoute type="POST" 
              link="/api/get_models"
              params={null}
              return={[{'id': "Model ID", 'name': "Model name", 'creationDate': "Model creation date", 'language': "Supported language"}]}
              description="Returns a list of all models currently available on the backend."/>
            <APIRoute type="POST" 
              link="/api/get_jobs"
              params={{'page': 'Page number (optional)'}}
              return={{'success': 'Status of the request', 'error': 'Error if the request failed', 'total_pages': 'Total number of pages',  'job_list': 'List of job ids'}}
              description="Returns a list of all public jobs submitted to the API, paginated with 10 jobs per request. The optional 'page' parameter can be used to fetch jobs from all pages less than or equal to 'total_pages'. If 'page' is not specified, it is assumed to be 1, i.e. the latest 10 jobs are fetched."/>
            <APIRoute type="POST"
              link="/api/submit_job"
              params={{'model_id': 'Specifies which model to use for processing', 'text': 'The text for speech synthesis', 'is_public': 'Boolean specifying if the request is public or private'}}
              return={{'success': 'Status of the request', 'job_id': 'ID of the submitted job'}}
              description="Submit's a job to the server and returns the job ID immediately. The job ID can be used to check the status of the job and fetch the final audio when it is ready. Public requests are visible to all visitors on the web interface of the API, while private requests do not appear in any listing and can only be accessed with the resulting job ID."/>
            <APIRoute type="POST"
              link="/api/get_info"
              params={{'job_id': 'ID of the job for which the information will be fetched'}}
              return={{'success': 'Status of the request', 'error': 'Error if the request failed', 'text': 'Text used for speech synthesis', 'model': 'Model name', 'creation_date': 'Job submission date and time', 'is_public': 'Boolean specifying if the job is public or not'}}
              description="Given a Job ID, returns information pertinent to the job, if it exists."/>
            <APIRoute
              type="POST"
              link="/api/get_status"
              params={{'job_id': 'ID of the job for which the status will be fetched'}}
              return={{'success': 'Status of the request', 'error': 'Error if the request failed', 'traceback': 'Traceback of the failed job, if it exists', 'status': 'Current status of the job'}}
              description="Returns the current status of the job specified by the job ID, if it exists. Status can either be 'done' or 'in progress'."/>
            <APIRoute type="GET"
              link="/api/audio/<job-id>.wav"
              params={"<job-id>.wav (in-url)"}
              return={"Audio file"}
              description="If the job status is 'done', this end point returns the generate audio as a 'wav' file."/>
          </div>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default APIReference;
